import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import { WA_URL } from '../../lib/wa';

export const HomesickMarket = () => (
  <section className="py-20 md:py-32 relative overflow-hidden">
    <div className="absolute inset-0 z-0">
      <img
        src="https://images.unsplash.com/photo-1605366721580-d69cc94b5b9c"
        alt="Indian family dining"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/80 to-transparent"></div>
    </div>

    <div className="container mx-auto px-6 relative z-10">
      <div className="max-w-3xl">
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Every Indian Abroad Misses Home.
        </h2>
        <p className="text-2xl md:text-3xl text-white/90 mb-8 leading-relaxed">
          The smell of dal tadka. The taste of real chai. The comfort of familiar brands.
        </p>
        <p className="text-xl md:text-2xl text-white/80 mb-10">
          Atlas brings that home — and puts <span className="text-amber-400 font-bold">your brand</span> in their hands.
        </p>
        <Button asChild size="lg" className="bg-amber-500 hover:bg-amber-600 text-white text-lg px-10 py-6 font-bold transition-all duration-300 hover:shadow-xl" data-testid="homesick-cta-btn">
          <a href={WA_URL} target="_blank" rel="noopener noreferrer">
            Be the Brand They Find
            <ArrowRight className="ml-2 h-5 w-5" />
          </a>
        </Button>
      </div>
    </div>
  </section>
);
